import { render, staticRenderFns } from "./EditWebConfig.vue?vue&type=template&id=7f9c9c34&scoped=true&"
import script from "./EditWebConfig.vue?vue&type=script&lang=ts&"
export * from "./EditWebConfig.vue?vue&type=script&lang=ts&"
import style0 from "./EditWebConfig.vue?vue&type=style&index=0&id=7f9c9c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c9c34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VTextField,VTextarea})
